window.axios = require("axios");
// window.axios.defaults.headers.common["X-WP-Nonce"] = settings.nonce;
import { createApp } from "vue";
import mixins from "./mixins";
import api from "./api";
import SvgVue from "svg-vue3";
import { UtilitiesHelpers } from "./utils/Utilities";
import LazyLoadDirective from "./directives/LazyLoadDirective";
import ClickOutside from "./directives/ClickOutside";
import GetInTouch from "./vueresources/GetInTouch.vue";
import 'vue-universal-modal/dist/index.css';
import VueUniversalModal from 'vue-universal-modal';
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let pricingApp = document.getElementById('pricing-app');
pricingApp = createApp({
        beforeCreate() {
            UtilitiesHelpers.vueFixWpPlugins(document.querySelector('#pricing-app'));
            UtilitiesHelpers.forceExternalLinks();
        },
    })
    .use(SvgVue)
    .use(VueUniversalModal, {
        teleportTarget: '#vue-modals',
    })
    .directive("lazyload", LazyLoadDirective)
    .directive("click-outside", ClickOutside);
pricingApp.config.globalProperties.$images = settings.images;
pricingApp.config.globalProperties.$settings = settings;
pricingApp.config.globalProperties.$api = api;
pricingApp.config.globalProperties.$nonce = settings.nonce;
pricingApp.mixin(mixins);
pricingApp.component("orely-pricing", GetInTouch);
pricingApp.mount('#pricing-app');
let timelineGetinTouch = gsap.timeline({
    paused: true, // default is false
    defaults: { // children inherit these defaults
        duration: 1.5,
        ease: "power2.out"
    },
    smoothChildTiming: true,
});
timelineGetinTouch
    .fromTo('.titlePage', {
        scale: 0.7,
        opacity:0
    }, {
        scale: 1,
        opacity:1,
        duration:.5
    }, '<.1')
    .fromTo('.imageHero', {
        scale: 1.2,
        opacity:0,
    }, {
        scale: 1,
        opacity:1,
        duration: 1
    }, '<.2')
    .fromTo('.Contact', {
        opacity: 0,
        scale: 0.8,
        opacity: 0,
        y: '10%'
    }, {
        scale: 1,
        y: '0%',
        opacity: 1,
        duration: .5,
        stagger: .2
    }, '<.1')
document.addEventListener("DOMContentLoaded", function () {
    let mainContent = document.getElementById('site');
    var preLoaderEl = document.querySelector('.preloader');
    if (preLoaderEl) {
        setTimeout(function () {
            preLoaderEl.classList.add('hide');
            mainContent.classList.remove('overflow-hidden');
            mainContent.classList.remove('opacity-0');
            mainContent.classList.add('opacity-100');
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
              });
              timelineGetinTouch.play();
        }, 1300)
    }
})